/* pi-search-drawer.js — Aurora right search drawer ====================== */
(function () {
  if (window.customElements.get('pi-search-drawer')) return;

  class PiSearchDrawer extends HTMLElement {
    constructor() {
      super();
      this.input = null;
      this.form = null;
      this.untrap = null;
      this.trigger = null;
      this.dialog = null;
      this.predictiveSearch = null;
      this.resultsPane = null;
      this.resultsFooter = null;
    }

    connectedCallback() {
      this.input = this.querySelector('.pi-search-drawer__input');
      this.form = this.querySelector('.pi-search-drawer__form-el');
      this.dialog = this.querySelector('.pi-search-drawer__dialog');
      this.closeBtns = this.querySelectorAll('[data-pi-search-close]');
      this.popularLinks = this.querySelectorAll('.pi-search-drawer__popular-link');
      this.predictiveSearch = this.querySelector('predictive-search');
      this.resultsPane = this.predictiveSearch?.querySelector('[data-predictive-search]');
      this.resultsFooter = this.querySelector('[data-pi-search-footer]');

      this.bindOpeners();
      this.bindControls();
      this.patchPredictiveSearch();
    }

    updateSeeAllLabel() {
      const seeAllLabel = window.piSearchDrawerStrings?.seeAll;
      const seeAllBtn = this.predictiveSearch?.querySelector('[data-predictive-search-search-for-text]');
      if (seeAllLabel && seeAllBtn) seeAllBtn.textContent = seeAllLabel;
    }

    moveCtaToFooter() {
      if (!this.resultsPane || !this.resultsFooter) return;

      const cta = this.resultsPane.querySelector('.predictive-search__search-for-button');
      if (!cta) {
        this.resultsFooter.hidden = true;
        return;
      }

      this.resultsFooter.appendChild(cta);
      this.resultsFooter.hidden = false;
      this.updateSeeAllLabel();
    }

    restoreCtaToPane() {
      if (!this.resultsPane || !this.resultsFooter) return;

      const cta = this.resultsFooter.querySelector('.predictive-search__search-for-button');
      const resultsRoot =
        this.resultsPane.querySelector('#predictive-search-results') || this.resultsPane;

      if (cta && resultsRoot) resultsRoot.appendChild(cta);

      this.resultsFooter.hidden = true;
    }

    patchPredictiveSearch() {
      if (!this.predictiveSearch) return;

      if (this.resultsPane) this.resultsPane.removeAttribute('hidden');

      const originalRender = this.predictiveSearch.renderSearchResults.bind(this.predictiveSearch);
      this.predictiveSearch.renderSearchResults = (markup) => {
        originalRender(markup);
        if (this.resultsPane) {
          this.resultsPane.style.maxHeight = '';
          this.resultsPane.style.overflowY = '';
          this.resultsPane.style.overflowX = '';
        }
        this.moveCtaToFooter();
      };

      const originalOpen = this.predictiveSearch.open.bind(this.predictiveSearch);
      this.predictiveSearch.open = () => {
        originalOpen();
        if (this.resultsPane) {
          this.resultsPane.style.maxHeight = '';
          this.resultsPane.style.overflowY = '';
          this.resultsPane.style.overflowX = '';
        }
        this.moveCtaToFooter();
      };

      const originalCloseResults = this.predictiveSearch.closeResults.bind(this.predictiveSearch);
      this.predictiveSearch.closeResults = (clearSearchTerm = false) => {
        if (this.resultsPane) {
          this.resultsPane.style.maxHeight = '';
          this.resultsPane.style.overflowY = '';
          this.resultsPane.style.overflowX = '';
        }
        originalCloseResults(clearSearchTerm);
        if (clearSearchTerm || !this.predictiveSearch.getAttribute('open')) {
          this.restoreCtaToPane();
        }
      };
    }

    bindOpeners() {
      document.querySelectorAll('[data-pi-search-open]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.open(btn);
        });
      });
    }

    bindControls() {
      this.closeBtns.forEach((btn) =>
        btn.addEventListener('click', () => this.close())
      );

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.dataset.open === 'true') this.close();
      });

      this.popularLinks.forEach((link) => {
        link.addEventListener('click', () => {
          const term = link.getAttribute('data-term') || link.textContent.trim();
          if (!this.input) return;
          this.input.value = term;
          this.input.focus({ preventScroll: true });
          this.input.dispatchEvent(new Event('input', { bubbles: true }));
        });
      });
    }

    open(triggeredBy) {
      this.trigger = triggeredBy || null;
      this.dataset.open = 'true';
      this.setAttribute('aria-hidden', 'false');
      if (triggeredBy) triggeredBy.setAttribute('aria-expanded', 'true');
      if (window.PiUtils) {
        window.PiUtils.lockScroll(this);
        this.untrap = window.PiUtils.trapFocus(this, this.input || this.dialog);
      }
      requestAnimationFrame(() => {
        if (this.input) this.input.focus({ preventScroll: true });
      });
    }

    close() {
      this.dataset.open = 'false';
      this.setAttribute('aria-hidden', 'true');
      if (this.trigger) this.trigger.setAttribute('aria-expanded', 'false');
      if (this.predictiveSearch?.isOpen) {
        this.predictiveSearch.close(true);
      }
      this.restoreCtaToPane();
      if (this.untrap) {
        this.untrap();
        this.untrap = null;
      }
      if (window.PiUtils) window.PiUtils.unlockScroll(this);
      if (this.trigger && typeof this.trigger.focus === 'function') {
        this.trigger.focus({ preventScroll: true });
      }
    }
  }

  window.customElements.define('pi-search-drawer', PiSearchDrawer);
})();
